import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

var ESC_KEY = 27;
var MOUSE_DOWN_EVENT = 'mousedown';
var KEY_DOWN_EVENT = 'keydown';
var ModalTitle = function (_a) {
    var title = _a.title, _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.roundCloseButton, roundCloseButton = _c === void 0 ? false : _c, handleClose = _a.handleClose;
    var titleClassName = clsx('c-modal__title', classes.title);
    var closeIconClassName = clsx('c-modal__close', classes.closeIcon, roundCloseButton && 'u--round');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: titleClassName }, title),
        React.createElement("div", { className: closeIconClassName, "data-testid": 'qa-close-button', onClick: handleClose })));
};
var ModalActions = function (_a) {
    var children = _a.children, className = _a.className, divProps = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: clsx('c-modal__buttons', className) }, divProps), children));
};
var ModalContent = function (_a) {
    var children = _a.children, className = _a.className, divProps = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({ className: clsx('c-modal__content', className) }, divProps), children));
};
var Modal = forwardRef(function (_a, ref) {
    var id = _a.id, isOpen = _a.isOpen, handleClose = _a.handleClose, _b = _a.designSize, designSize = _b === void 0 ? 'small' : _b, _c = _a.ignoreOutsideClicks, ignoreOutsideClicks = _c === void 0 ? false : _c, children = _a.children, className = _a.className, _d = _a.container, container = _d === void 0 ? document.getElementById('modal') || document.getElementsByTagName('body')[0] : _d, divProps = __rest(_a, ["id", "isOpen", "handleClose", "designSize", "ignoreOutsideClicks", "children", "className", "container"]);
    var wrapperRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                handleClose();
            }
        };
        var handleClickESC = function (event) {
            if (event.keyCode === ESC_KEY) {
                handleClose();
            }
        };
        if (isOpen) {
            if (!ignoreOutsideClicks) {
                document.addEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            }
            document.addEventListener(KEY_DOWN_EVENT, handleClickESC);
        }
        return function () {
            if (!ignoreOutsideClicks) {
                document.removeEventListener(MOUSE_DOWN_EVENT, handleClickOutside);
            }
            document.removeEventListener(KEY_DOWN_EVENT, handleClickESC);
        };
    }, [isOpen, handleClose, ignoreOutsideClicks]);
    return isOpen
        ? createPortal(React.createElement("div", { ref: ref, key: id, className: clsx('c-modal', className) },
            React.createElement("div", __assign({ ref: wrapperRef, className: clsx('c-modal__window', "c-modal__window--".concat(designSize), className) }, divProps), children)), container)
        : null;
});

export { Modal, ModalActions, ModalContent, ModalTitle, Modal as default };
//# sourceMappingURL=index.js.map
